<div style="border: 1px solid #dddddd; padding: 10px;">
    <form [formGroup]="impuestoComplementoForm">
        <div class="row justify-content-start align-items-center">
            <div class="col-sm-12 col-md-3 col-xl-3 ">
                <mat-label>Impuesto</mat-label>
                <mat-form-field class="inputFullWide" appearance="fill">
                    <mat-select placeholder="Selecciona un valor" formControlName="impuestoComplemento" (selectionChange)="actualizarTasaComplemento($event.value)">
                        <mat-option *ngFor="let impuesto of impuestos" [value]="impuesto.id">
                            {{ impuesto.attributes.impuesto }}
                        </mat-option>
                    </mat-select>
                    <!-- <mat-error *ngIf="formDatosCliente.get('rFC').hasError ('required')"><strong>*Este campo es obligatorio</strong></mat-error> -->
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-3 col-xl-3 ">
                <mat-form-field class="inputFullWide">
                    <mat-label>Base</mat-label>
                    <input matInput formControlName="baseComplemento" (change)="calculateTotalComplemento();">
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-3 col-xl-3 ">
                <mat-label>Tasa</mat-label>
                <mat-form-field class="inputFullWide" appearance="fill">
                    <mat-select placeholder="Selecciona una tasa" formControlName="tasaComplemento" (selectionChange)="calculateTotalComplemento()">
                        <mat-option *ngFor="let tasa of tasasDinamica" [value]="tasa">
                            {{ tasa?.attributes?.nombre }}
                        </mat-option>
                    </mat-select>
                    <!-- <mat-error *ngIf="formDatosCliente.get('rFC').hasError ('required')"><strong>*Este campo es obligatorio</strong></mat-error> -->
                 </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-3 col-xl-3 ">
                <mat-form-field class="inputFullWide">
                    <mat-label>Total</mat-label>
                    <input matInput formControlName="totalComplemento">
                </mat-form-field>
            </div>
        </div>
    </form>
</div>
<br>